var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Toolbar" }, [
    _c(
      "div",
      { staticClass: "pano-wb-tb" },
      [
        _c(
          "div",
          {
            staticClass: "pano-wb-tb__item pano-withtip",
            class: {
              "pano-wb-tb__item": true,
              "pano-withtip": true,
              "pano-wb-tb__item--selected":
                _vm.insertType === _vm.Constants.ShapeType.Select,
            },
            attrs: { "data-tip": "选择" },
            on: {
              click: function ($event) {
                return _vm.setToolType(_vm.Constants.ShapeType.Select)
              },
            },
          },
          [_c("span", { staticClass: "iconfont icon-mouse-pointer" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "pano-withtip": true,
              "pano-wb-tb__item": true,
              "pano-wb-tb__item--selected":
                _vm.insertType === _vm.Constants.ShapeType.Pen,
            },
            attrs: { "data-tip": "画笔" },
            on: {
              click: function ($event) {
                return _vm.setToolType(_vm.Constants.ShapeType.Pen)
              },
            },
          },
          [_c("span", { staticClass: "iconfont icon-pencil" })]
        ),
        _vm._v(" "),
        _c("el-popover", { attrs: { placement: "right", trigger: "click" } }, [
          _c("div", { staticClass: "pano-wb-popup" }, [
            _c("div", { staticClass: "pano-wb-popup__item" }, [
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.insertType === _vm.Constants.ShapeType.Line,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setToolType(_vm.Constants.ShapeType.Line)
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-minus" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.insertType === _vm.Constants.ShapeType.Arrow,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setToolType(_vm.Constants.ShapeType.Arrow)
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-arrow-left2" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.fillType === "none" &&
                      _vm.insertType === _vm.Constants.ShapeType.Ellipse,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setToolType(_vm.Constants.ShapeType.Ellipse)
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-radio-unchecked" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.fillType === "none" &&
                      _vm.insertType === _vm.Constants.ShapeType.Rect,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setToolType(_vm.Constants.ShapeType.Rect)
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "iconfont icon-checkbox-unchecked",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.fillType === "color" &&
                      _vm.insertType === _vm.Constants.ShapeType.Ellipse,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSolidToolType(
                        _vm.Constants.ShapeType.Ellipse
                      )
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-circle-h" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.fillType === "color" &&
                      _vm.insertType === _vm.Constants.ShapeType.Rect,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSolidToolType(_vm.Constants.ShapeType.Rect)
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-rect-h" })]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "pano-withtip": true,
                "pano-wb-tb__item": true,
                "pano-wb-tb__item--selected":
                  _vm.fillType === "none" &&
                  (_vm.insertType === _vm.Constants.ShapeType.Line ||
                    _vm.insertType === _vm.Constants.ShapeType.Arrow ||
                    _vm.insertType === _vm.Constants.ShapeType.Rect ||
                    _vm.insertType === _vm.Constants.ShapeType.Ellipse),
              },
              attrs: { slot: "reference", "data-tip": "图形" },
              slot: "reference",
            },
            [
              _c("span", { staticClass: "iconfont icon-hollow" }),
              _vm._v(" "),
              _c("div", { staticClass: "pano-wb-tb__item__triangle" }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("el-popover", { attrs: { placement: "right", trigger: "click" } }, [
          _c(
            "div",
            {
              class: {
                "pano-wb-tb__item": true,
                "pano-withtip": true,
                "pano-wb-tb__item--selected":
                  _vm.insertType === _vm.Constants.ShapeType.Text,
              },
              attrs: { slot: "reference", "data-tip": "文本" },
              on: {
                click: function ($event) {
                  return _vm.setToolType(_vm.Constants.ShapeType.Text)
                },
              },
              slot: "reference",
            },
            [
              _c("span", { staticClass: "iconfont icon-text" }),
              _vm._v(" "),
              _c("div", { staticClass: "pano-wb-tb__item__triangle" }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pano-wb-popup" }, [
            _c(
              "div",
              {
                class: {
                  "pano-wb-popup__item__select": true,
                  "pano-wb-popup__item__select--selected": _vm.bold,
                },
                on: { click: _vm.toggleBold },
              },
              [_c("span", { staticClass: "iconfont icon-bold" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "pano-wb-popup__item__select": true,
                  "pano-wb-popup__item__select--selected": _vm.italic,
                },
                on: { click: _vm.toggleItalic },
              },
              [_c("span", { staticClass: "iconfont icon-italic" })]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "pano-withtip": true,
              "pano-wb-tb__item": true,
              "pano-wb-tb__item--selected": _vm.penetrable,
            },
            attrs: {
              "data-tip": _vm.penetrable ? "关闭点击穿透" : "开启点击穿透",
            },
            on: { click: _vm.togglePenetrable },
          },
          [
            _c("svg-icon", {
              staticClass: "iconfont",
              attrs: { "icon-class": "penetrate" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "pano-withtip": true,
              "pano-wb-tb__item": true,
              "pano-wb-tb__item--selected": _vm.isWhiteboardHidden,
            },
            attrs: {
              "data-tip": _vm.isWhiteboardHidden ? "显示轨迹" : "隐藏轨迹",
            },
            on: { click: _vm.toggleHidden },
          },
          [
            _c("svg-icon", {
              staticClass: "iconfont",
              attrs: { "icon-class": "path" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-popover", { attrs: { placement: "right", trigger: "click" } }, [
          _c("div", { staticClass: "pano-wb-popup" }, [
            _c(
              "div",
              { staticClass: "pano-wb-popup__item" },
              [
                _c("span", { staticClass: "pano-wb-popup__item__label" }, [
                  _vm._v("线宽："),
                ]),
                _vm._v(" "),
                _c("el-slider", {
                  staticStyle: { flex: "1", "max-width": "140px" },
                  attrs: { value: _vm.lineWidth, step: 1, min: 1, max: 20 },
                  on: { input: _vm.setLineWidth },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pano-wb-popup__item" },
              [
                _c("span", { staticClass: "pano-wb-popup__item__label" }, [
                  _vm._v("字号："),
                ]),
                _vm._v(" "),
                _c("el-slider", {
                  staticStyle: { flex: "1", "max-width": "140px" },
                  attrs: { step: 2, min: 12, max: 60, value: _vm.fontSize },
                  on: { input: _vm.setFontSize },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pano-wb-popup__item" },
              _vm._l(_vm.colors, function (color) {
                return _c(
                  "div",
                  {
                    key: color,
                    staticClass: "pano-wb-popup__item__colors",
                    on: {
                      click: function ($event) {
                        return _vm.selectColor(color)
                      },
                    },
                  },
                  [
                    _c("div", {
                      class: {
                        "pano-wb-popup__item__colors__color-dot": true,
                        "pano-wb-popup__item__colors__color-dot--selected":
                          _vm.selectedColor === color,
                      },
                      style: {
                        backgroundColor: color,
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pano-wb-tb__item pano-withtip",
              attrs: { slot: "reference", "data-tip": "工具箱" },
              slot: "reference",
            },
            [
              _c("span", { staticClass: "iconfont icon-tools" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "pano-wb-tb__item__color-dot",
                style: { backgroundColor: _vm.selectedColor },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("el-popover", { attrs: { placement: "right", trigger: "click" } }, [
          _c("div", { staticClass: "wb-img-inputs-wrapper" }, [
            _c("div", { staticClass: "wb-img-wrapper" }, [
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.insertType === _vm.Constants.ShapeType.Line,
                  },
                  on: { click: _vm.uploadImage },
                },
                [_c("span", { staticClass: "iconfont icon-images" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.insertType === _vm.Constants.ShapeType.Line,
                  },
                  on: { click: _vm.uploadImage },
                },
                [
                  _c("svg-icon", {
                    staticClass: "iconfont icon-audio",
                    staticStyle: { "font-size": "16px" },
                    attrs: { "icon-class": "audio" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "pano-wb-popup__item__select": true,
                    "pano-wb-popup__item__select--selected":
                      _vm.insertType === _vm.Constants.ShapeType.Line,
                  },
                  on: { click: _vm.uploadImage },
                },
                [_c("span", { staticClass: "iconfont icon-video-camera1" })]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pano-wb-tb__item pano-withtip",
              attrs: { slot: "reference", "data-tip": "上传媒体" },
              slot: "reference",
            },
            [
              _c("svg-icon", {
                staticClass: "iconfont",
                attrs: { "icon-class": "media" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "pano-wb-tb__item__triangle" }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "pano-wb-tb__item pano-withtip",
          attrs: { "data-tip": "上传文档" },
          on: { click: _vm.uploadFileAndTranscode },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "pano-withtip": true,
              "pano-wb-tb__item": true,
              "pano-wb-tb__item--selected":
                _vm.insertType === _vm.Constants.ShapeType.Eraser,
            },
            attrs: { "data-tip": "橡皮擦" },
            on: {
              click: () => {
                this.whiteboard.setToolType(_vm.Constants.ShapeType.Eraser)
                this.insertType = _vm.Constants.ShapeType.Eraser
              },
            },
          },
          [_c("span", { staticClass: "iconfont icon-eraser" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "pano-withtip": true,
              "pano-wb-tb__item": true,
              "pano-wb-tb__item--selected":
                _vm.insertType === _vm.Constants.ShapeType.Delete,
            },
            attrs: { "data-tip": "点选删除" },
            on: {
              click: () => {
                this.whiteboard.setToolType(_vm.Constants.ShapeType.Delete)
                this.insertType = _vm.Constants.ShapeType.Delete
              },
            },
          },
          [_c("span", { staticClass: "iconfont icon-delete" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "pano-wb-tb__item": true,
              "pano-withtip": true,
              "pano-wb-tb__item--selected":
                _vm.insertType === _vm.Constants.ShapeType.LaserPointer,
            },
            attrs: { "data-tip": "激光笔" },
            on: {
              click: function ($event) {
                return _vm.setToolType(_vm.Constants.ShapeType.LaserPointer)
              },
            },
          },
          [
            _c("span", {
              staticClass: "iconfont icon-laserPointer",
              staticStyle: { "font-size": "20px" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pano-wb-tb__item pano-withtip",
            attrs: { "data-tip": "撤销" },
            on: { click: _vm.undo },
          },
          [_c("span", { staticClass: "iconfont icon-undo" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pano-wb-tb__item pano-withtip",
            attrs: { "data-tip": "重做" },
            on: { click: _vm.redo },
          },
          [_c("span", { staticClass: "iconfont icon-redo" })]
        ),
        _vm._v(" "),
        _c(
          "el-popover",
          { attrs: { placement: "right", trigger: "click" } },
          [
            _c("FileList", { attrs: { parentDOM: "teacher", fileList: [] } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pano-wb-tb__item pano-withtip",
                attrs: { slot: "reference", "data-tip": "文件列表" },
                slot: "reference",
              },
              [
                _c("svg-icon", {
                  staticClass: "iconfont",
                  attrs: { "icon-class": "file" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeDocId != _vm.classData.lessonDocId,
            expression: "activeDocId != classData.lessonDocId",
          },
        ],
        staticClass: "wb-docs",
      },
      [
        _c(
          "el-dropdown",
          { attrs: { trigger: "click" } },
          [
            _c("el-button", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.activeDoc.name == "default"
                      ? "白板"
                      : _vm.activeDoc.name
                  ) +
                  "\n        "
              ),
              _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
            ]),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              _vm._l(_vm.docs, function (doc, index) {
                return _c(
                  "el-dropdown-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: doc.docId != _vm.classData.lessonDocId,
                        expression: "doc.docId != classData.lessonDocId",
                      },
                    ],
                    key: doc.docId,
                    class: {
                      "wb-docs__item": true,
                      "wb-docs__item--active": _vm.activeDocId === doc.docId,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.switchDoc(doc.docId, doc)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          index === 0
                            ? "白板"
                            : doc.fileKey != _vm.lessonDocId
                            ? doc.name
                            : "课件"
                        ) +
                        "\n          "
                    ),
                    index !== 0 && doc.fileKey != _vm.lessonDocId
                      ? _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title: "确认删除文档?",
                              okText: "是",
                              cancelText: "否",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.deleteDoc(doc.docId)
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont icon-delete",
                              style: { marginLeft: "3px", fontSize: "12px" },
                              attrs: { slot: "reference" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                              slot: "reference",
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.uploading
      ? _c("div", { staticClass: "wb-upload-progress" }, [
          _c("div", {
            staticClass: "wb-upload-progress__loaded",
            style: { width: `${_vm.uploadProgress * 100}%` },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "pano-wb-pages pano-wb-tools" }, [
      _c("div", { staticClass: "pano-wb-pages__wrapper" }, [
        _vm.thumbUrls.length
          ? _c(
              "button",
              {
                staticClass: "pano-withtip pano-withtip-top pano-wb-pages__btn",
                style: { paddingRight: "6px" },
                attrs: { "data-tip": "课件预览" },
                on: {
                  click: function ($event) {
                    return _vm.setDrawerVisible(true)
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "iconfont icon-files-empty",
                  style: { fontSize: "14px" },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pano-withtip pano-withtip-top pano-wb-pages__btn",
            style: { paddingLeft: "6px" },
            attrs: { "data-tip": "前一页" },
            on: {
              click: function ($event) {
                return _vm.updatePageIndex(_vm.pageIndex - 1)
              },
            },
          },
          [
            _c("span", {
              staticClass: "iconfont icon-angle-double-left",
              style: { fontSize: "16px" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pano-wb-pages__page-count" }, [
          _vm._v(
            "\n        " +
              _vm._s(`${_vm.pageIndex + 1} / ${_vm.pageCount}`) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pano-withtip pano-withtip-top pano-wb-pages__btn",
            attrs: { "data-tip": "后一页" },
            on: {
              click: function ($event) {
                return _vm.updatePageIndex(_vm.pageIndex + 1)
              },
            },
          },
          [
            _c("span", {
              staticClass: "iconfont icon-angle-double-right",
              style: { fontSize: "16px" },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.activeDocId === "default"
          ? _c(
              "button",
              {
                staticClass: "pano-withtip pano-withtip-top pano-wb-pages__btn",
                attrs: { "data-tip": "填加一页" },
                on: { click: _vm.addPage },
              },
              [
                _c("span", {
                  staticClass: "iconfont icon-plus",
                  style: { fontSize: "10px" },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.activeDocId === "default"
          ? _c(
              "button",
              {
                staticClass: "pano-withtip pano-withtip-top pano-wb-pages__btn",
                attrs: { "data-tip": "删除当前页" },
                on: { click: _vm.removePage },
              },
              [
                _c("span", {
                  staticClass: "iconfont icon-minus",
                  style: { fontSize: "10px" },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.drawerVisible
      ? _c("div", {
          staticClass: "wb-courseware-alide-mask",
          on: {
            click: function ($event) {
              return _vm.setDrawerVisible(false)
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.thumbUrls.length
      ? _c(
          "aside",
          {
            class: {
              "wb-courseware-alide": true,
              "wb-courseware-alide__hiden": !_vm.drawerVisible,
            },
          },
          [
            _c("header", [
              _c("span", [_vm._v("课件预览")]),
              _vm._v(" "),
              _c("i", {
                staticClass: "iconfont icon-close",
                style: { fontSize: "14px" },
                on: {
                  click: function ($event) {
                    return _vm.setDrawerVisible(false)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wb-courseware-list" },
              _vm._l(_vm.thumbUrls, function (url, index) {
                return _c(
                  "div",
                  { key: url, staticClass: "courseware-preview" },
                  [
                    _c("img", {
                      class: {
                        "courseware-preview__active": _vm.pageIndex === index,
                      },
                      attrs: { src: url, alt: "thumbnail" },
                      on: {
                        click: function ($event) {
                          return _vm.updatePageIndex(index)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "courseware-index" }, [
                      _c("span", [_vm._v(_vm._s(index + 1))]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/whiteboard/Toolbar.vue?vue&type=template&id=9334526a&
// module id = null
// module chunks = 